import { Component, OnInit } from '@angular/core';
import { DadosService } from '../services/service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dados',
  templateUrl: './dados.component.html',
  styleUrls: ['./dados.component.css']
})
export class DadosComponent implements OnInit {

  constructor(private dadosService: DadosService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    let cnpj = this.route.snapshot.params['id'];
    this.dadosService.buscaDados(cnpj)
      .subscribe(dados => {
      });
  }

  

  

}



// WEBPACK FOOTER //
// ./src/app/dados/dados.component.ts